<template>
  <div class="d-s-s d-c" style="height: calc(100vh - 122px);" v-loading="loading" v-if="homeshow">
    <!-- 刷新 -->
    <div class="zui">
      <!-- <div style="margin-top:10px;padding-left: 50px;" @click="openFullScreen1">
        <i class="el-icon-refresh-right"></i> 刷新
      </div> -->
      <el-button style="margin: 10px 0 0 50px;" type="primary" icon="el-icon-refresh-right"
        @click="openFullScreen1">刷新</el-button>
      <div class="zhufu">
        <!-- <div class="fuhao">
          <img src="https://fw-admin-2022.jiulove.cn/assets/addons/shopro/img/dashboard/payOrder-icon.png" />
          支付订单
        </div> -->
      </div>
      <div class="zhufu1">

        <!-- <div class="fuhao">
          <img src="https://fw-admin-2022.jiulove.cn/assets/addons/shopro/img/dashboard/payAmount-icon.png" />
          支付金额
        </div> -->
      </div>
      <div class="block" style="position: relative;z-index: 9;">
        <el-date-picker v-model="datePicker" type="datetimerange" :picker-options="pickerOptions"
          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" align="right" @change="shijianchange">
        </el-date-picker>
      </div>
      <div style="margin-top:10px;margin-left: 10px;z-index: 99;">
        <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
      </div>
      <div style="margin-top:10px;margin-left: 10px;z-index: 99;">
        <el-button size="small" type="success" @click="keshihua()">数字可视化大屏</el-button>
      </div>
      <div style="margin-top:10px;margin-left: 10px;z-index: 99;">
        <el-button size="small" type="primary" @click="openFullScreen1()">刷新</el-button>
      </div>
    </div>

    <!-- 内容 -->
    <div class="shui">
      <div class="shui1">
        <!-- 第一个div -->
        <div class="dise shadow-bolder">
          <div class="disrow">
            <div>
              <span class="shenqing">总租金</span>
              <span class="shenqing1"> {{ rent.totalRent }}元</span>
            </div>
            <div>
              <span class="shenqing">待还租金</span>
              <span class="shenqing1"> {{ rent.rentRepaid }}元</span>
            </div>
            <div id="demo"></div>
          </div>
          <div class="diyi">
            <div class="biankuang">
              <span class="yihuan">
                已还租金<br />
                {{ rent.rentPaid }}</span>
            </div>
            <div class="biankuang">
              <span class="yujiao">实付金额<br />
                {{ rent.advanceRent }}</span>
            </div>
            <div class="biankuang">
              <span class="zhudong">主动还款<br />
                {{ rent.activeRepayment }}</span>
            </div>
          </div>

          <div class="diyi">
            <div class="biankuang">
              <span class="yihuan">
                买断金额<br />
                {{ rent.pendingBuyout }}</span>
            </div>
            <div class="biankuang">
              <span class="yujiao">逾期金额<br />
                {{ rent.yuqiRepayment }}</span>
            </div>
            <div class="biankuang">
              <span class="zhudong">代扣金额<br />
                {{ rent.daikouRepayment }}</span>
            </div>
          </div>
        </div>
        <!-- 第二个div -->
        <div class="dier shadow-bolder">
          <!-- 上边的div -->
          <div>
            <div>
              <span class="shenqing">申请总单数<br /></span>
              <span class="shenqing1">
                {{ singular.totalNumberApplications }}单</span>
            </div>
            <div>
              <div id="demo2"></div>
            </div>
          </div>
          <!-- 下边的div -->
          <div class="suiping1">
            <div class="you">
              <span class="xinyong">信用免押单数<br />
                {{ singular.numberCreditChargeFreeDocuments }}</span>
            </div>
            <div class="you1">
              <span class="yushou">预授权单数<br />
                {{ singular.numberPreAuthorizationOrders }}</span>
            </div>
          </div>
        </div>
        <!-- 第三个div -->
        <div class="dier shadow-bolder">
          <!-- 上边的div -->
          <div>
            <div>
              <span class="shenqing">驳回单数<br /></span>
              <span class="shenqing1">
                {{ numberRejectionOrders.numberRejectionOrders }}单</span>
            </div>
            <div>
              <div id="demo3"></div>
            </div>
          </div>
          <!-- 下边的div -->
          <div class="suiping1">
            <div class="you">
              <span class="xinyong">信用免押单数<br />
                {{
                  numberRejectionOrders.numberCreditChargeFreeDocuments
                }}</span>
            </div>
            <div class="you1">
              <span class="yushou">预授权单数<br />
                {{ numberRejectionOrders.numberPreAuthorizationOrders }}</span>
            </div>
          </div>
        </div>
        <!-- 第四个div -->
        <div class="dier shadow-bolder">
          <!-- 上边的div -->
          <div>
            <div>
              <span class="shenqing">成交单数(当日)<br /></span>
              <span class="shenqing1">
                {{ numberTransactionOrders.numberRejectionOrders }}单</span>
            </div>
            <div>
              <div id="demo4"></div>
            </div>
          </div>
          <!-- 下边的div -->
          <div class="suiping1">
            <div class="you">
              <span class="xinyong">信用免押单数<br />
                {{
                  numberTransactionOrders.numberCreditChargeFreeDocuments
                }}</span>
            </div>
            <div class="you1">
              <span class="yushou">预授权单数<br />
                {{ numberTransactionOrders.numberPreAuthorizationOrders }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="shui1">
        <!-- 第五个div -->
        <div class="diwu shadow-bolder">
          <div>
            <div>
              <span class="shenqing">会员人总数<br /></span>
              <span class="shenqing1">{{ user.totalNumberMembers }}人</span>
            </div>
            <div>
              <span class="shenqing"> 日/注册<br /></span>
              <span class="shenqing1" style="color: #C23531;">
                {{ user.dayRegistration }}人</span>
            </div>
            <div id="demo5"></div>
          </div>

          <div></div>
        </div>
        <!-- 第六个div -->
        <div class="diliu shadow-bolder">
          <div class="titledata">
            预授权资金转租金
          </div>
          <div>
            <span class="shenqing">支付金额<br /></span>
            <span class="shenqing1">{{ advanceRent.paymentAmount }}元</span>
          </div>
        </div>
        <!-- 第七个div -->
        <div class="diqi shadow-bolder">
          <div class="titledata">
            未付款客户总数
          </div>
          <div>
            <span class="shenqing">未支付人数<br /></span>
            <span class="shenqing1"> {{ Unpaid.numberUnpaidPersons }}人</span>
          </div>
        </div>
        <!-- 第八个div -->
        <div class="diba shadow-bolder">
          <div class="titledata">
            成交订单的总合同金额
          </div>
          <div>
            <span class="shenqing">成交金额<br /></span>
            <span class="shenqing1">
              {{ totalContractAmountClosedOrders.transactionAmount }}元</span>
          </div>
        </div>
      </div>

      <div class="shui1">
        <!-- 第九个div -->
        <div class="dijiu shadow-bolder">
          <div>
            <span class="shenqing">支付渠道<br /></span>
            <br />
          </div>
          <div id="demo8"></div>
          <div>
            <span class="shenqing"> 成交单数<br /> </span>
            <span class="bi">{{ paymentChannel.alipayPayment }}笔</span>
            <span class="zhigubao">支付宝支付</span>
          </div>
        </div>
        <!-- 第十个div -->
        <div class="dishi shadow-bolder">
          <!-- 上边的div -->
          <div>
            <div>
              <span class="shenqing">成交单数<br /></span>
              <span class="shenqing1">{{
                totalNumberTransactionOrders.numberRejectionOrders
              }}单</span>
            </div>
            <div id="demo6"></div>
          </div>
          <!-- 下边的div -->
          <div class="suiping1">
            <div class="you">
              <span class="xinyong">信用免押单数<br />
                {{
                  totalNumberTransactionOrders.numberCreditChargeFreeDocuments
                }}</span>
            </div>
            <div class="you1">
              <span class="yushou">预授权单数<br />
                {{
                  totalNumberTransactionOrders.numberPreAuthorizationOrders
                }}</span>
            </div>
          </div>
        </div>
        <!-- 第十一个div -->
        <div class="dishiyi shadow-bolder">
          <!-- 上边的div -->
          <div>
            <div>
              <span class="shenqing">成交单量<br /></span>
              <span class="shenqing1">
                {{
                  overdueNumberTransactionOrders.numberRejectionOrders
                }}单</span>
            </div>
            <div id="demo7"></div>
          </div>
          <!-- 下边的div -->
          <div class="suiping1">
            <div class="you">
              <span class="xinyong">履约单量<br />
                {{
                  overdueNumberTransactionOrders.numberCreditChargeFreeDocuments
                }}</span>
            </div>
            <div class="you1">
              <span class="yushou">
                逾期单量<br />
                {{
                  overdueNumberTransactionOrders.numberPreAuthorizationOrders
                }}</span>
            </div>
          </div>
        </div>
        <!-- 第十二个div  暂无信息-->
        <div style="padding: 5px 20px; width: 350px; height: 200px;">
          <!-- 上边的div -->
          <div>
            <div>
              <span class="shenqing"><br /></span>
              <span class="shenqing1"> </span>
            </div>
            <div id="demo7"></div>
          </div>
          <!-- 下边的div -->
          <div class="suiping1">
            <div class="you">
              <span class="xinyong"><br /> </span>
            </div>
            <div class="you1">
              <span class="yushou">
                <br />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IndexApi from "@/api/index.js";
import AuthApi from "@/api/auth.js";
import Transaction from "@/views/home/part/Transaction.vue";
import { formatDate } from "@/utils/DateTime.js";
import pieChart from "@/views/home/part/product/pieChart.vue"; //引入组件
export default {
  components: {
    Transaction,
    pieChart
  },
  data() {
    let endDate = new Date();
    let startDate = new Date();
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 0);
    return {
      homeshow: true,
      roleList: "",
      //第一个饼状图
      map: "",
      option: {
        title: {
          // subtext: "纯属虚构",
          left: "center" //标题位置
        },
        tooltip: {
          //鼠标hover覆盖提示框

          trigger: "item", //根据item提示信息
          formatter: "{b} : {c} ({d}%)" //提示内容
        },
        legend: {
          //位于右侧的属性按钮
          orient: "vertical", //竖直放置
          icon: "circle", //图标为圆形，默认是方形
          bottom: "bottom",
          itemGap: 6, //两个属性的距离
          itemWidth: 8, //图标的宽度，对应有itemHeight为高度,圆形只有半径
          // x: "60%", //距离左侧位置
          // y: "55%", //距离上面位置
          align: "left" //图标与属性名的相对位置，默认为right，即属性名在左，图标在右

          // textStyle: {
          //属性名的字体样式设置
          // fontSize: 10,
          // color: "#000",
          // },
        },

        series: [
          //饼状图设置
          {
            type: "pie", //类型为饼状
            // hoverAnimation: false, //鼠标悬停效果，默认是true
            center: ["50%", "70%"], //饼状图位置，第一个参数是左右，第二个是上下。
            radius: ["40%", "45%"], //内圈半径，外圈半径
            hoverAnimation: true, //鼠标悬停效果，默认是true
            data: [{ value: 335 }, { value: 310 }],
            label: {
              normal: {
                formatter: "{d}%",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 15
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      //第二个饼状图
      map2: "",
      option2: {
        width: "100%",
        height: "100%",
        // title: {
        //   subtext: "申请总单数",
        //   left: "center", //标题位置
        // },
        tooltip: {
          //鼠标hover覆盖提示框
          trigger: "item", //根据item提示信息
          formatter: "单数 : {c}" //提示内容
        },
        legend: {
          //位于右侧的属性按钮
          orient: "vertical", //竖直放置
          icon: "circle", //图标为圆形，默认是方形
          bottom: "bottom",
          itemGap: 6, //两个属性的距离
          itemWidth: 8, //图标的宽度，对应有itemHeight为高度,圆形只有半径
          // x: "60%", //距离左侧位置
          // y: "55%", //距离上面位置
          align: "left", //图标与属性名的相对位置，默认为right，即属性名在左，图标在右

          textStyle: {
            // 属性名的字体样式设置
            fontSize: 10,
            color: "#000"
          }
        },
        series: [
          //饼状图设置
          {
            type: "pie", //类型为饼状
            // hoverAnimation: false, //鼠标悬停效果，默认是true
            center: ["50%", "70%"], //饼状图位置，第一个参数是左右，第二个是上下。
            radius: ["35%", "40%"], //内圈半径，外圈半径
            hoverAnimation: true, //鼠标悬停效果，默认是true
            data: [{ value: 50 }, { value: 100 }],
            label: {
              normal: {
                formatter: "{c}单",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 15
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      //第三个饼状图
      map3: "",
      option3: {
        width: "100%",
        height: "100%",
        title: {
          // subtext: "纯属虚构",
          left: "center" //标题位置
        },
        tooltip: {
          //鼠标hover覆盖提示框

          trigger: "item", //根据item提示信息
          formatter: "单数:{c}单" //提示内容
        },
        legend: {
          //位于右侧的属性按钮
          orient: "vertical", //竖直放置
          icon: "circle", //图标为圆形，默认是方形
          bottom: "bottom",
          itemGap: 6, //两个属性的距离
          itemWidth: 8, //图标的宽度，对应有itemHeight为高度,圆形只有半径
          // x: "60%", //距离左侧位置
          // y: "55%", //距离上面位置
          align: "left" //图标与属性名的相对位置，默认为right，即属性名在左，图标在右

          // textStyle: {
          //属性名的字体样式设置
          // fontSize: 10,
          // color: "#000",
          // },
        },
        series: [
          //饼状图设置
          {
            type: "pie", //类型为饼状
            // hoverAnimation: false, //鼠标悬停效果，默认是true
            center: ["50%", "70%"], //饼状图位置，第一个参数是左右，第二个是上下。
            radius: ["35%", "40%"], //内圈半径，外圈半径
            hoverAnimation: true, //鼠标悬停效果，默认是true
            data: [{ value: 50 }, { value: 100 }],
            label: {
              normal: {
                formatter: "{c}单",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 15
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      //第四个饼状图
      map4: "",
      option4: {
        width: "100%",
        height: "100%",
        title: {
          // subtext: "纯属虚构",
          left: "center" //标题位置
        },
        tooltip: {
          //鼠标hover覆盖提示框

          trigger: "item", //根据item提示信息
          formatter: "单数:{c}单" //提示内容
        },
        legend: {
          //位于右侧的属性按钮
          orient: "vertical", //竖直放置
          icon: "circle", //图标为圆形，默认是方形
          bottom: "bottom",
          itemGap: 6, //两个属性的距离
          itemWidth: 8, //图标的宽度，对应有itemHeight为高度,圆形只有半径
          // x: "60%", //距离左侧位置
          // y: "55%", //距离上面位置
          align: "left" //图标与属性名的相对位置，默认为right，即属性名在左，图标在右

          // textStyle: {
          //属性名的字体样式设置
          // fontSize: 10,
          // color: "#000",
          // },
        },
        series: [
          //饼状图设置
          {
            type: "pie", //类型为饼状
            // hoverAnimation: false, //鼠标悬停效果，默认是true
            center: ["50%", "70%"], //饼状图位置，第一个参数是左右，第二个是上下。
            radius: ["35%", "40%"], //内圈半径，外圈半径
            hoverAnimation: true, //鼠标悬停效果，默认是true
            data: [{ value: 50 }, { value: 100 }],
            label: {
              normal: {
                formatter: "{c}单",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 15
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      //第五个饼状图 会员人总数
      map5: "",
      option5: {
        title: {
          // subtext: " 会员人总数",
          left: "center" //标题位置
        },
        tooltip: {
          //鼠标hover覆盖提示框

          trigger: "item", //根据item提示信息
          formatter: "人数:{c} " //提示内容
        },
        legend: {
          //位于右侧的属性按钮
          orient: "vertical", //竖直放置
          icon: "circle", //图标为圆形，默认是方形
          bottom: "bottom",
          itemGap: 6, //两个属性的距离
          itemWidth: 8, //图标的宽度，对应有itemHeight为高度,圆形只有半径
          // x: "60%", //距离左侧位置
          // y: "55%", //距离上面位置
          align: "left" //图标与属性名的相对位置，默认为right，即属性名在左，图标在右

          // textStyle: {
          // // 属性名的字体样式设置
          // fontSize: 10,
          // color: "#000",
          // },
        },
        series: [
          //饼状图设置
          {
            type: "pie", //类型为饼状
            // hoverAnimation: false, //鼠标悬停效果，默认是true
            center: ["50%", "55%"], //饼状图位置，第一个参数是左右，第二个是上下。
            radius: ["35%", "40%"], //内圈半径，外圈半径
            hoverAnimation: true, //鼠标悬停效果，默认是true
            data: [{ value: 50 }, { value: 100 }],
            label: {
              normal: {
                formatter: "{c}/人",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 15
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      //第六个饼状图
      map6: "",
      option6: {
        width: "100%",
        height: "100%",
        title: {
          // subtext: "纯属虚构",
          left: "center" //标题位置
        },
        tooltip: {
          //鼠标hover覆盖提示框

          trigger: "item", //根据item提示信息
          formatter: "单数:{c}单" //提示内容
        },
        legend: {
          //位于右侧的属性按钮
          orient: "vertical", //竖直放置
          icon: "circle", //图标为圆形，默认是方形
          bottom: "bottom",
          itemGap: 6, //两个属性的距离
          itemWidth: 8, //图标的宽度，对应有itemHeight为高度,圆形只有半径
          // x: "60%", //距离左侧位置
          // y: "55%", //距离上面位置
          align: "left" //图标与属性名的相对位置，默认为right，即属性名在左，图标在右

          // textStyle: {
          //属性名的字体样式设置
          // fontSize: 10,
          // color: "#000",
          // },
        },
        series: [
          //饼状图设置
          {
            type: "pie", //类型为饼状
            // hoverAnimation: false, //鼠标悬停效果，默认是true
            center: ["50%", "70%"], //饼状图位置，第一个参数是左右，第二个是上下。
            radius: ["35%", "40%"], //内圈半径，外圈半径
            hoverAnimation: true, //鼠标悬停效果，默认是true
            data: [{ value: 50 }, { value: 100 }],
            label: {
              normal: {
                formatter: "{c}单",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 15
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      //第七个饼状图
      map7: "",
      option7: {
        width: "100%",
        height: "100%",
        title: {
          // subtext: "纯属虚构",
          left: "center" //标题位置
        },
        tooltip: {
          //鼠标hover覆盖提示框

          trigger: "item", //根据item提示信息
          formatter: "单数:{c}单" //提示内容
        },
        legend: {
          //位于右侧的属性按钮
          orient: "vertical", //竖直放置
          icon: "circle", //图标为圆形，默认是方形
          bottom: "bottom",
          itemGap: 6, //两个属性的距离
          itemWidth: 8, //图标的宽度，对应有itemHeight为高度,圆形只有半径
          // x: "60%", //距离左侧位置
          // y: "55%", //距离上面位置
          align: "left" //图标与属性名的相对位置，默认为right，即属性名在左，图标在右

          // textStyle: {
          //属性名的字体样式设置
          // fontSize: 10,
          // color: "#000",
          // },
        },
        series: [
          //饼状图设置
          {
            type: "pie", //类型为饼状
            // hoverAnimation: false, //鼠标悬停效果，默认是true
            center: ["50%", "70%"], //饼状图位置，第一个参数是左右，第二个是上下。
            radius: ["35%", "40%"], //内圈半径，外圈半径
            hoverAnimation: true, //鼠标悬停效果，默认是true
            data: [{ value: 50 }, { value: 100 }],
            label: {
              normal: {
                formatter: "{c}单",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 15
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      //第八个饼状图  支付渠道
      map8: "",
      option8: {
        width: "100%",
        height: "100%",
        title: {
          // subtext: "纯属虚构",
          left: "center" //标题位置
        },
        tooltip: {
          //鼠标hover覆盖提示框

          trigger: "item", //根据item提示信息
          formatter: "单数:{c}单" //提示内容
        },
        legend: {
          //位于右侧的属性按钮
          orient: "vertical", //竖直放置
          icon: "circle", //图标为圆形，默认是方形
          bottom: "bottom",
          itemGap: 6, //两个属性的距离
          itemWidth: 8, //图标的宽度，对应有itemHeight为高度,圆形只有半径
          // x: "40%", //距离左侧位置
          // y: "40%", //距离上面位置
          align: "left" //图标与属性名的相对位置，默认为right，即属性名在左，图标在右

          // textStyle: {
          //属性名的字体样式设置
          // fontSize: 10,
          // color: "#000",
          // },
        },
        series: [
          //饼状图设置
          {
            type: "pie", //类型为饼状
            // hoverAnimation: false, //鼠标悬停效果，默认是true
            center: ["50%", "70%"], //饼状图位置，第一个参数是左右，第二个是上下。
            radius: ["35%", "40%"], //内圈半径，外圈半径
            hoverAnimation: true, //鼠标悬停效果，默认是true
            data: [{ value: 50 }, { value: 100 }],
            label: {
              normal: {
                formatter: "{c}单",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: 15
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      starttime: "",
      endtime: "",
      //时间
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      datePicker: [
        formatDate(startDate, "yyyy-MM-dd 00:00:00"),
        formatDate(endDate, "yyyy-MM-dd 23:59:59")
      ],
      /*是否加载完成*/
      loading: true,
      /*统计信息*/
      top_data: [],
      /*待办事项*/
      wait_data: {
        order: {},
        agent: {},
        supplier: {},
        activity: {},
        audit: {}
      },
      /*今日数据*/
      today_data: {
        order_total_price: {},
        order_total: {},
        new_user_total: {},
        new_supplier_total: {},
        apply_supplier_total: {}
      },
      //租金
      rent: {
        totalRent: {}, //总租金
        rentRepaid: {}, //待还租金
        pendingBuyout: {}, //待还买断
        rentPaid: {}, //已还租金
        advanceRent: {}, //预交租金
        activeRepayment: {} //主动还款
      },
      singular: {
        totalNumberApplications: {}, //申请总单数
        numberCreditChargeFreeDocuments: {}, //信用免押单数
        numberPreAuthorizationOrders: {} //预授权单数
      },
      numberRejectionOrders: {
        numberRejectionOrders: {}, //驳回单数
        numberCreditChargeFreeDocuments: {}, //信用免押单数
        numberPreAuthorizationOrders: {} //预授权单数
      },
      numberTransactionOrders: {
        numberRejectionOrders: {}, //成交单数(当日)
        numberCreditCharge_freeDocuments: {}, //信用免押单数
        numberPre_authorizationOrders: {} //预授权单数
      },
      user: {
        totalNumberMembers: {}, //会员总人数
        dayRegistration: {} //日/注册
      },
      advanceRent: {
        totalAmountPrepaidRent: {}, //预交租金总金额
        paymentAmount: {} //支付金额
      },
      Unpaid: {
        totalNumberUnpaidCustomers: {}, //未付款客户总数
        numberUnpaidPersons: {} //未支付人数
      },
      totalContractAmountClosedOrders: {
        transactionAmount: {} //成交金额
      },
      paymentChannel: {
        alipayPayment: {} //支付宝支付
      },
      totalNumberTransactionOrders: {
        numberRejectionOrders: {}, //成交单数
        numberCreditChargeFreeDocuments: {}, //信用免押单数
        numberPreAuthorizationOrders: {} //预授权单数
      },
      overdueNumberTransactionOrders: {
        numberRejectionOrders: {}, //成交单量
        numberCreditChargeFreeDocuments: {}, //履约单量
        numberPreAuthorizationOrders: {} //逾期单量
      }
    };
  },
  mounted() {
    // 这个方法不能放在greated生命周期,因为那时候dom还没初始化完成
    this.echarts();
  },
  inject: ["baseInfo"],
  created() {
    /*获取数据*/
    this.getTableList();
    this.getData();
    this.getshuju();
  },
  methods: {
    // 可视化
    keshihua() {
      window.open("https://shoujizulin2.rchz.top/visualization", "target");
    },
    /*搜索查询*/
    onSubmit() {
      this.getData();
      this.getshuju();
    },
    echarts() {
      // 引入 ECharts 主模块
      var echarts = require("echarts/lib/echarts");
      // 引入柱状图(这个例子可以去掉)
      require("echarts/lib/chart/bar");
      // 引入提示框和标题组件
      require("echarts/lib/component/tooltip");
      require("echarts/lib/component/title");
      //第一个的饼状图
      // 基于准备好的dom，初始化echarts实例
      // 绘制饼图
      this.map = echarts.init(document.getElementById("demo"));
      this.map.setOption(this.option, true);
      //第二个的饼状图
      this.map2 = echarts.init(document.getElementById("demo2"));
      this.map2.setOption(this.option2, true);
      //第三个的饼状图
      this.map3 = echarts.init(document.getElementById("demo3"));
      this.map3.setOption(this.option3, true);
      //第四个的饼状图
      this.map4 = echarts.init(document.getElementById("demo4"));
      this.map4.setOption(this.option4, true);
      //第五个的饼状图
      this.map5 = echarts.init(document.getElementById("demo5"));
      this.map5.setOption(this.option5, true);
      //第六个的饼状图
      this.map6 = echarts.init(document.getElementById("demo6"));
      this.map6.setOption(this.option6, true);
      //第七个的饼状图
      this.map7 = echarts.init(document.getElementById("demo7"));
      this.map7.setOption(this.option7, true);
      //第八个的饼状图
      this.map8 = echarts.init(document.getElementById("demo8"));
      this.map8.setOption(this.option8, true);
    },
    //第一个的饼状图
    btn(a1, a2) {
      this.option.series[0].data[0].value = a1;
      this.option.series[0].data[1].value = a2;
      // 重新渲染
      this.map.setOption(this.option, true);
    },
    //第二个的饼状图
    btn2(a1, a2) {
      this.option2.series[0].data[0].value = a1;
      this.option2.series[0].data[1].value = a2;
      // 重新渲染
      this.map2.setOption(this.option2, true);
    },
    //第三个的饼状图
    btn3(a1, a2) {
      this.option3.series[0].data[0].value = a1;
      this.option3.series[0].data[1].value = a2;
      // 重新渲染
      this.map3.setOption(this.option3, true);
    },
    //第四个的饼状图
    btn4(a1, a2) {
      this.option4.series[0].data[0].value = a1;
      this.option4.series[0].data[1].value = a2;
      // 重新渲染
      this.map4.setOption(this.option4, true);
    },
    //第五个的饼状图
    btn5(a1, a2) {
      this.option5.series[0].data[0].value = a1;
      this.option5.series[0].data[1].value = a2;
      // 重新渲染
      this.map5.setOption(this.option5, true);
    },
    //第六个的饼状图
    btn6(a1, a2) {
      this.option6.series[0].data[0].value = a1;
      this.option6.series[0].data[1].value = a2;
      // 重新渲染
      this.map6.setOption(this.option6, true);
    },
    //第七个的饼状图
    btn7(a1, a2) {
      this.option7.series[0].data[0].value = a1;
      this.option7.series[0].data[1].value = a2;
      // 重新渲染
      this.map7.setOption(this.option7, true);
    },
    //第八个的饼状图
    btn8(a1, a2) {
      this.option8.series[0].data[0].value = a1;
      this.option8.series[0].data[1].value = a2;
      // 重新渲染
      this.map8.setOption(this.option8, true);
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      AuthApi.userList(Params, true)
        .then(data => {
          self.roleList = data.data.list.data;
          // console.log("roleList",self.roleList);
          // console.log("baseInfo",self.baseInfo.user.user_name);
          let datainfo = self.roleList;
          for (let item of datainfo) {
            // console.log(item.user_name);
            if (item.user_name == self.baseInfo.user.user_name) {
              // console.log(item.role_id);
              if (item.role_id == 4) {
                self.homeshow = false;
              } else {
                self.homeshow = true;
              }
            }
          }
        })
        .catch(error => { });
    },

    /*选择时间*/
    shijianchange() {
      // this.getData();
      // this.getshuju();
    },
    //on-change事件
    switchAR(item) {
      console.log(item.target.value);
    },
    //刷新
    openFullScreen1() {
      // this.fullscreenLoading = true;
      // setTimeout(() => {
      //   this.fullscreenLoading = false;
      // }, 2000);
      this.getData();
      this.getshuju();
    },
    /*获取数据*/
    getData() {
      let self = this;
      self.starttime = self.datePicker[0];
      self.endtime = self.datePicker[1];
      IndexApi.getCount(true)
        .then(data => {
          self.top_data = data.data.data.top_data;
          self.wait_data = data.data.data.wait_data;
          self.today_data = data.data.data.today_data;
        })
        .catch(error => { });
    },
    getshuju() {
      let alldata = {};
      let self = this;
      self.loading = true;
      let bingzhuangtu = 0;
      let shju = {
        startTime: self.starttime,
        endTime: self.endtime
      };
      IndexApi.dataCenter(shju, true)
        .then(data => {
          // console.log(data.data.data);
          alldata.rent = data.data.data.rent;
          bingzhuangtu = (alldata.rent.rentPaid / alldata.rent.totalRent) * 100;
          self.rent = alldata.rent;
          //第一个饼状图
          self.btn(alldata.rent.rentRepaid, alldata.rent.rentPaid);
          self.$message({
            message: "加载成功",
            type: "success"
          });
          self.loading = false;
        })
        .catch(error => { });

      IndexApi.dataCenter2(shju, true)
        .then(data => {
          // console.log(data.data.data);
          alldata.singular = data.data.data.singular;
          //第二个饼状图
          self.btn2(
            alldata.singular.numberCreditChargeFreeDocuments,
            alldata.singular.totalNumberApplications
          );
          self.singular = alldata.singular;
        })
        .catch(error => { });

      IndexApi.dataCenter3(shju, true)
        .then(data => {
          // console.log(data.data.data);
          alldata.numberRejectionOrders = data.data.data.numberRejectionOrders;
          alldata.numberTransactionOrders =
            data.data.data.numberTransactionOrders;
          //第三个饼状图
          self.btn3(
            alldata.numberRejectionOrders.numberCreditChargeFreeDocuments,
            alldata.numberRejectionOrders.numberRejectionOrders
          );
          //第四个饼状图
          self.btn4(
            alldata.numberTransactionOrders.numberCreditChargeFreeDocuments,
            alldata.numberTransactionOrders.numberRejectionOrders
          );
          self.numberRejectionOrders = alldata.numberRejectionOrders;
          self.numberTransactionOrders = alldata.numberTransactionOrders;
        })
        .catch(error => { });

      IndexApi.dataCenter4(shju, true)
        .then(data => {
          // console.log(data.data.data);
          let data1 = data.data.data.user.totalNumberMembers;
          var value = parseInt(data1.replace(",", ""));
          data.data.data.user.totalNumberMembers = value;
          alldata.user = data.data.data.user;
          alldata.advanceRent = data.data.data.advanceRent;
          //第五个饼状图
          self.btn5(
            alldata.user.dayRegistration,
            alldata.user.totalNumberMembers
          );
          self.user = alldata.user;
          self.advanceRent = alldata.advanceRent;
        })
        .catch(error => { });

      IndexApi.dataCenter6(shju, true)
        .then(data => {
          // console.log(data.data.data);
          alldata.paymentChannel = data.data.data.paymentChannel;
          alldata.totalContractAmountClosedOrders =
            data.data.data.totalContractAmountClosedOrders;

          //   //第八个饼状图
          this.btn8(data.data.data.paymentChannel.alipayPayment, "");
          self.paymentChannel = alldata.paymentChannel;
          self.totalContractAmountClosedOrders =
            alldata.totalContractAmountClosedOrders;
        })
        .catch(error => { });

      IndexApi.dataCenter7(shju, true)
        .then(data => {
          // console.log(data.data.data);
          alldata.Unpaid = data.data.data.Unpaid;
          self.Unpaid = alldata.Unpaid;
        })
        .catch(error => { });

      IndexApi.dataCenter5(shju, true)
        .then(data => {
          // console.log(data.data.data);
          alldata.overdueNumberTransactionOrders =
            data.data.data.overdueNumberTransactionOrders;
          alldata.totalNumberTransactionOrders =
            data.data.data.totalNumberTransactionOrders;
          //第六个饼状图
          self.btn6(
            alldata.totalNumberTransactionOrders
              .numberCreditChargeFreeDocuments,
            alldata.totalNumberTransactionOrders.numberRejectionOrders
          );
          //第七个饼状图
          self.btn7(
            alldata.totalNumberTransactionOrders
              .numberCreditChargeFreeDocuments,
            alldata.totalNumberTransactionOrders.numberRejectionOrders
          );
          self.overdueNumberTransactionOrders =
            alldata.overdueNumberTransactionOrders;
          self.totalNumberTransactionOrders =
            alldata.totalNumberTransactionOrders;
        })
        .catch(error => { });
    }
  }
};
</script>

<style lang="scss" scoped>
.disrow {
  display: flex;
  margin-left: 35px;
}

.operation-wrap {
  width: 100%;
  height: 164px;
  border-radius: 8px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 0 20px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  background-size: 100% 100%;
  color: #ffffff;
}

.operation-wrap .grid-content h3 {
  font-size: 36px;
  line-height: 40px;
}

.operation-wrap .grid-content .info {
  text-align: center;
  margin-left: 10px;
}

.home .operation-wrap .grid-content {
  width: 90%;
  height: 150px;
  justify-content: flex-start;
  align-items: center;
  padding-left: 23px;
}

.operation-wrap .grid-content.blue {
  background: url(../../../static/imgs/total_shop.png) no-repeat;
  background-size: 100% 100%;
}

.operation-wrap .grid-content.yellow {
  background: url(../../../static/imgs/total_user.png) no-repeat;
  background-size: 100% 100%;
}

.operation-wrap .grid-content.purple {
  background: url(../../../static/imgs/total_volume.png) no-repeat;
  background-size: 100% 100%;
}

.operation-wrap .grid-content.orderred {
  background: url(../../../static/imgs/total_order.png) no-repeat;
  background-size: 100% 100%;
}

.operation-wrap .grid-content .info h3 {
  font-size: 40px;
  line-height: 40px;
  color: #ffffff;
  text-align: left;
  margin-bottom: 20px;
}

.operation-wrap .grid-content .info {
  margin-left: 10px;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
}

.operation-wrap .grid-content .svg-icon {
  color: rgba(255, 255, 255, 0.3);
  font-size: 300%;
}

.home-index {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  min-width: 1000px;
  overflow-x: auto;
}

.main-index {
  flex: 1;
  margin: 20px;
}

.main-index .grid-content,
.operation-wrap .grid-content {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.main-index .grid-content {
  height: 120px;
}

.main-index .grid-content .pic {
  margin-right: 10px;
}

.main-index .grid-content h3 {
  font-size: 20px;
  font-weight: normal;
}

.main-index .grid-content .yesterday {
  color: #ccc;
}

.main-index .grid-content .svg-icon {
  color: #3a8ee6;
}

.matters-wrap {
  padding-bottom: 15px;
  width: 40%;
}

.matters .box {
  width: 100%;
}

.matters-wrap .matters {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  // height: 120px;
  margin-bottom: 30px;
}

.matters-wrap .matters .title {
  font-size: 16px;
  color: #333333;
  display: inline-block;
  height: 20px;
  line-height: 0;
  padding: 11px;
  text-align: center;
  margin-bottom: 20px;
}

.matters-wrap .matters ul {
  color: #999999;
}

.matters-wrap .matters ul span {
  padding-right: 6px;
  color: #3a8ee6;
}

.border-b {
  display: flex;
  flex-direction: column;
}

.border-b-l {
  flex-direction: initial;
}

.matters_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.matters_item li {
  width: 72px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
}

.grid-content .info h3 {
  font-weight: bold;
  color: #5d75e3;
  text-align: center;
}

.grid-content .info .des {
  font-size: 16px;
  margin-bottom: 6px;
}

.grid-content .info .yesterday {
  font-size: 13px;
  text-align: center;
}

.matters_box {
  width: 90%;
  border-top: 1px solid #d9d9d9;
  padding-top: 20px;
}

.matters-wrap .matters_item li .fb {
  font-size: 16px;
  color: #5d75e3;
}

.suiping1 {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  justify-content: center;
}

.shui {
  width: 100%;
  flex: 1;
  // display: flex;
  // flex-direction: row;
  // flex-wrap: wrap;
  // justify-content: flex-start;
  align-items: center;
  background: #f1f4f6;
  padding: 10px;
}

.shui1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}

.shui>div {
  margin: 30px 40px;
}

.dise {
  width: 350px;
  height: 200px;
  padding-top: 10px;
  background: #fff;
  // background: radial-gradient(circle at 100px 100px, #fff, #fff 10px, #c4d6f1);
  border-radius: 8px;
}

.zui {
  width: 100%;
  background: #f1f4f6;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
}

.zhufu {
  margin-left: 20px;
  margin-top: 10px;
  font-size: 10px;
}

.zhufu1 {
  margin-left: 40px;
  margin-top: 10px;
}

.fuhao {
  font-size: 13px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 18px;
    height: 10px;
  }
}

.shi {
  margin-left: 500px;
  margin-top: 5px;
  font-size: 19px;
}

.block {
  margin-left: 200px;
  margin-top: 10px;
}

.dier {
  width: 350px;
  height: 200px;
  background: #fff;
  border-radius: 8px;
  padding: 10px 20px;
}

.diyi {
  margin-left: 15px;
  margin-top: 25px;
  display: flex;
  flex-direction: row;
}

.diyi .biankuang {
  margin-left: 20px;
}

.shuipingyidong {
  display: flex;
  flex-direction: row;
}

.diwu {
  width: 350px;
  height: 200px;
  background: #fff;
  border-radius: 8px;
  padding: 10px 20px;
}

.diliu {
  width: 350px;
  height: 200px;
  background: #fff;
  border-radius: 8px;
  padding: 25px 25px;
}

.diqi {
  width: 350px;
  height: 200px;
  background: #fff;
  border-radius: 8px;
  padding: 25px;
}

.diba {
  width: 350px;
  height: 200px;
  background: #fff;
  border-radius: 8px;
  padding: 25px;
}

.dijiu {
  padding: 5px 20px;
  width: 350px;
  height: 200px;
  background: #fff;
  border-radius: 8px;
}

.dishi {
  padding: 5px 20px;
  width: 350px;
  height: 200px;
  background: #fff;
  border-radius: 8px;
}

.dishiyi {
  padding: 5px 20px;
  width: 350px;
  height: 200px;
  background: #fff;
  border-radius: 8px;
}

.zongzujin {
  margin-left: 20px;
}

.qian {
  margin-left: 20px;
  color: #753ecd;
  font-size: 20px;
}

.daihuan {
  // margin-left: 20px;
  color: rgb(27, 20, 255);
  font-size: 15px;
}

.yihuan {
  font-size: 15px;
}

.yujiao {
  color: rgb(27, 20, 255);
  font-size: 15px;
}

.zhudong {
  color: green;
  font-size: 15px;
}

.xinyong {
  margin-left: 50rpx;
  font-size: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: red;
}

.yushou {
  margin-left: 50px;
  color: rgb(27, 20, 255);
  font-size: 15px;
}

.you {
  text-align: center;
}

.you1 {
  text-align: center;
}

.shenqing {
  font-size: 20px;
  color: #666;
  font-weight: 400;
}

.bi {
  font-size: 20px;
  margin-left: 20px;
  color: #753ecd;
}

.zhigubao {
  font-size: 20px;
  margin-left: 130px;
  margin-top: -100px;
}

.shenqing1 {
  font-size: 20px;
  font-weight: bold;
  margin-top: 10px;
  color: #753ecd;
}

.titledata {
  margin-bottom: 50px;
  font-size: 18px;
  color: #666;
  font-weight: 600;
}

#demo {
  // margin-left: 90px;
  // margin-top: -105px;
  // width: 300px;
  // height: 120px;
}

#demo2 {
  margin-left: 60px;
  margin-top: -145px;
  width: 300px;
  height: 200px;
}

#demo3 {
  margin-left: 60px;
  margin-top: -145px;
  width: 300px;
  height: 200px;
}

#demo4 {
  margin-left: 60px;
  margin-top: -145px;
  width: 300px;
  height: 200px;
}

#demo5 {
  margin-left: 65px;
  margin-top: -145px;
  width: 300px;
  height: 200px;
}

#demo6 {
  margin-left: 60px;
  margin-top: -145px;
  width: 300px;
  height: 200px;
}

#demo7 {
  margin-left: 60px;
  margin-top: -145px;
  width: 300px;
  height: 200px;
}

#demo8 {
  margin-left: 60px;
  margin-top: -145px;
  width: 300px;
  height: 200px;
}

.shadow-bolder {
  box-shadow: 1px 2px 4px #0001, -1px -1px 1px #0002;
}

.shadow-bolder:hover {
  transform: scale(1.05);
  box-shadow: 1px 2px 8px #0002, -1px -1px 4px #0004;
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue